'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.cjs');
var MetaplexError = require('../../errors/MetaplexError.cjs');

/** @group Errors */
class NftError extends MetaplexError.MetaplexError {
  constructor(message, cause) {
    super(message, 'plugin', 'NFT', cause);
    _rollupPluginBabelHelpers.defineProperty(this, "name", 'NftError');
  }
}

/** @group Errors */
class ParentCollectionMissingError extends NftError {
  constructor(mint, operation) {
    const message = `You are trying to send the operation [${operation}] which requires the NFT to have ` + `a parent collection but that is not the case for the NFT at address [${mint}]. ` + 'Ensure the NFT you are interacting with has a parent collection.';
    super(message);
    _rollupPluginBabelHelpers.defineProperty(this, "name", 'ParentCollectionMissingError');
  }
}

/** @group Errors */
class DelegateRoleRequiredDataError extends NftError {
  constructor(type) {
    const message = `You are trying to approve a delegate of type "${type}" ` + `but did not provide any data for that role. Please provide the "data" ` + 'attribute as the SDK cannot provide a default value for that role.';
    super(message);
    _rollupPluginBabelHelpers.defineProperty(this, "name", 'DelegateRoleRequiredDataError');
  }
}

exports.DelegateRoleRequiredDataError = DelegateRoleRequiredDataError;
exports.NftError = NftError;
exports.ParentCollectionMissingError = ParentCollectionMissingError;
//# sourceMappingURL=errors.cjs.map
